import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';

const namespace = 'features.invoices.index.mass_actions';

function ExportButton({
  invoiceIds,
  disabled,
  queryParams,
  urlPath,
  translationKey,
  iconClass = 'fa-file-export',
  className = 'qmb-control'
}) {
  const handleExport = useCallback(() => {
    let url = urlPath;
    let params = new URLSearchParams();

    if (invoiceIds) {
      const idsArray = invoiceIds.split(',');
      idsArray.forEach((id) => params.append('ids[]', id.trim()));
      params = params.toString();
    } else {
      params = queryParams;
    }

    if (params.toString()) {
      url += `?${params}`;
    }

    window.location.href = url;
  }, [invoiceIds, queryParams]);

  return (
    <button type="button" className={className} disabled={disabled} onClick={handleExport}>
      <i className={`fa-light ${iconClass}`} />
      {translate(translationKey, { namespace })}
    </button>
  );
}

ExportButton.propTypes = {
  invoiceIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired,
  urlPath: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  iconClass: PropTypes.string,
  className: PropTypes.string
};

ExportButton.defaultProps = {
  invoiceIds: null,
  iconClass: 'fa-file-export',
  className: 'qmb-control'
};

export default ExportButton;
